// Settings Context - src/context/Settings
import React, { useState } from "react";

const SearchContext = React.createContext();

export const SearchProvider = ({ children, settings }) => {
  const [drName, setDrName] = useState("");
  const [categories, setCategories] = useState([]);
  const [experienceYears, setExperienceYears] = React.useState(null);
  const [rating, setIsRating] = React.useState(0);
  const [category, setCategory] = useState("");
  const [servingAreas, setServingAreas] = useState("");
  const [gender, setGender] = useState("");
  const [input, setinput] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [district, setDistrict] = useState(null);
  const [doctorId, setDoctorId] = useState(null);

  return (
    <SearchContext.Provider
      value={{
        drName,
        setDrName,
        categories,
        setCategories,
        experienceYears,
        setExperienceYears,
        rating,
        setIsRating,
        category,
        setCategory,
        servingAreas,
        setServingAreas,
        gender,
        setGender,
        input,
        setinput,
        openDrawer,
        setOpenDrawer,
        district,
        setDistrict,
        doctorId,
        setDoctorId,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const SearchConsumer = SearchContext.Consumer;

export default SearchContext;
